import React, { useEffect, useState } from 'react';
import * as API from './api/api';
import imgAnswersIcon from './img/answers-icon.png';
import imgQuestionIcon from './img/question-icon.png';


export default function User() {


    const [userToken, setUserToken] = useState(localStorage.getItem('userToken'));
    const [sessionCode, setSessionCode] = useState(localStorage.getItem('sessionCode') || '');
    const [sessionData, setSessionData] = useState(null);
    const [userDetails, setUserDetails] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [ showImagePopup, setShowImagePopup ] = useState(false);
    const [ popupImageUrl, setPopupImageUrl ] = useState('');
    const [ showAnswersPopup, setShowAnswersPopup ] = useState(false);
    const [ popupUserAnswersData, setPopupUserAnswersData ] = useState(null);

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

    const [timer, setTimer] = useState(-1);

    const [hasSubmitted, setHasSubmitted] = useState(false);


     useEffect(() => {
        
        const timeout = setTimeout(() => {
            if(timer <= 1) {    
                if(!hasSubmitted && sessionData && sessionData.status === 'active') {
                    submitAnswers();
                    setHasSubmitted(true);
                }
                return;
            }
            setTimer(timer - 1);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [timer]); 


    const [firstName, setFirstName] = useState(localStorage.getItem('firstName') ||  null);


    const letters = ['A', 'B', 'C', 'D', 'E', 'F'];

    function askForLogout() {
      if (window.confirm('Are you sure you want to log out?')) {
        setFirstName(null);
        setUserToken(null);
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('className');
        localStorage.removeItem('userToken');
        localStorage.removeItem('sessionCode');

        window.location.href = '/';
      }
    } 

    function askForExitSession() {
      if (window.confirm('Are you sure you want to exit the session?')) {
        setSessionCode('');
        setSessionData(null);
        localStorage.removeItem('sessionCode');

        window.location.href = '/';
      }
    } 

    var timerInterval = 0;

    useEffect(() => {
        setTimeout(() => {
            const firstInput = document.querySelector(`[data-index="0"]`);
            if (firstInput) {
                firstInput.focus();
            } 
        }, 300);

    }, []); 

    useEffect(() => {
        if(userToken) {
            API.GetUserDetails().then(response => {
                if (response.Status === 'ok') {
                    setUserDetails(response);
                } else {
                    console.error('Failed to retrieve user details');
                }   
            });
        }
        GetSessionData();
    }, [sessionCode]);

  
  function CaptureSessionCode(event, i) 
    {
       const value = event.target.value;
       const charInputs = Array.from(document.querySelectorAll('.one-char-input'));
  
       if (value.length === 1 && i < charInputs.length - 1) {
            document.querySelector(`[data-index="${i + 1}"]`).focus();
        }
        // check if all inputs are filled
        const allFilled = Array.from(document.querySelectorAll('.one-char-input')).every(input => input.value.length === 1);
        if (allFilled) {
            const code = Array.from(document.querySelectorAll('.one-char-input')).map(input => input.value).join('');
            setSessionCode(code);
            localStorage.setItem('sessionCode', code);
        }
    }

    function toggleButton(event, quizId, answerId) {
        const button = event.target;
        const quiz = button.getAttribute('data-quiz');
        const answer = button.getAttribute('data-answer');

        if (button.classList.contains('selected')) {
            button.classList.remove('selected');
        } else {
            button.classList.add('selected');
        }

        var selectedAnswers = '';
        document.querySelectorAll('.answer-btn.selected').forEach(button => {
            const answer = button.getAttribute('data-answer');  
            if (!selectedAnswers.includes(answer)) {
                selectedAnswers += answer + ',';
            }
        });
        sessionData.quizzes[currentQuestionIndex].selectedAnswer = selectedAnswers.slice(0, -1);

        console.log('Selected answers:', sessionData.quizzes[currentQuestionIndex].selectedAnswer);
    }

    function nextQuestion() {
        if(currentQuestionIndex < sessionData.quizzes.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    }

    function submitAnswers() {
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);

        const selectedAnswers = [];
        sessionData.quizzes.forEach(quiz => {
            const quizId = quiz.quiz;
            selectedAnswers.push({ quiz: quizId, answer: quiz.selectedAnswer || '' });
        });

        API.SubmitAnswers({ sessionCode: sessionCode, answers: selectedAnswers }).then(response => {
            if (response.success) {
                GetSessionData();
                window.location.href = '/';
            } else {
                alert('Failed to submit answers. Please try again.');
            }
        }).catch(error => {
            console.error('Submit answers failed', error);
            alert('An error occurred while submitting answers. Please try again.');
        }).finally(() => {
            setIsSubmitting(false);
        });
    } 


    function GetSessionData() {
        if(timerInterval !== 0) {
            clearInterval(timerInterval);
            timerInterval = 0;
        }
        if(sessionCode) {
            API.GetSessionData(sessionCode).then(response => {
                if (response.status === 'active' || response.status === 'submitted') {
                    setSessionData(response);

                    if(response.status === 'active') {

                        const cTimer = parseInt(response.duration) - (response.currentTS - response.startedAt);
                        setTimer(cTimer);
                        console.log('Initial timer set to:', cTimer);
                        if(cTimer <= 0) {
                            localStorage.removeItem('sessionCode');
                            window.location.href = '/';
                            return;
                        }   
                    }
                } else {
                    console.error('Failed to load session data');
                    setSessionCode(null);
                    localStorage.removeItem('sessionCode');
                    window.location.href = '/';
                }
            });
        }
    }

    function formatTime(seconds) {
        if(seconds === '' || isNaN(seconds) || seconds < 0) {
            return '--:--';
        }
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    function GetRankPositionColor(rank){
        if (rank === 1) return '#ffd700'; // gold
        if (rank === 2) return '#c0c0c0'; // silver
        if (rank === 3) return '#cd7f31'; // bronze
        return 'inherit';
    }


    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === 'hidden') {
            setTimer(timer - 5); // Penalize user by reducing timer by 5 seconds when they switch away from the page
            console.log('Penalized by 5 seconds');
        } else if (document.visibilityState === 'visible') {
            setTimer(timer - 5); // Penalize user by reducing timer by 5 seconds when they switch away from the page
            console.log('Penalized by 5 seconds'); 
        }
    });

    return (
        <>
        <div id="header">
            {firstName && (<div id="user-name" onClick={askForLogout}>{firstName}</div>)}
            <div>{timer > 0 ? formatTime(timer) : ''}</div>
            {sessionCode && (<div id="session-code" onClick={askForExitSession}>{sessionCode}</div>)}
        </div>
        
        { !sessionCode && (
            <div className="form-container form-container-500 white-background padding20">
                <h2>Enter Session Code</h2>
                <div className="otp-container" id="otpContainer">
                {Array(6).fill(0).map((_, i) => (
                        <input key={i} type="text" className="one-char-input" maxLength="1" data-index={i} onChange={(e) => CaptureSessionCode(e, i)} />
                    ))}
                </div>
                <div id="statusMessage" className="status-message"></div>
            </div>
          )}

          { sessionCode && !sessionData && (
             <div className="form-container form-container-500white-background padding20">
                <p style={{ textAlign: 'center' }}>Loading session data...</p>
              </div>
          )}

          { sessionData && (
                <div>
                {sessionData.status === 'submitted' && (
                  <div className="form-container form-container-500 white-background padding20">
                    <h2>Your points: {sessionData.points3}</h2>
                    <p style={{ textAlign: 'center' }}>Your answers have been submitted. Thank you for participating!</p>
                    <p style={{ textAlign: 'center' }}>Please wait for the session to end to see your position!</p>
                    
                  </div>
                )}
                {sessionData.status === 'active' && (



                  <div>
                    <h3>Quizzes:</h3>
                    <div className="form-container" style={{ maxWidth: '1200px' }}>
                        <div className="quiz-grid" id="quizGrid">
                          {sessionData.quizzes.filter((_, i) => i === currentQuestionIndex).map((quiz, index) => (
                            <div key={index} className="quiz-card">
                              <div className="quiz-title">Question {quiz.quiz}</div>
                                      <img src={quiz.image} alt={`Question ${quiz.quiz}`} className="quiz-image" />
                                      <div className="quiz-content">
                                          
                                          <div className="answer-buttons" data-quiz="{quiz.quiz}">
                                              {Array(quiz.answers).fill(0).map((_, i) => (
                                                  <button key={index + '_' + i + '_' + quiz.quiz} 
                                                    onClick={(e) => toggleButton(e, quiz.quiz, i + 1)} 

                                                    className="answer-btn" data-quiz={quiz.quiz} data-answer={letters[i]}>
                                                      {letters[i]}
                                                  </button>
                                              ))}
                                          </div>
                                      </div>
                                  </div>
                          ))}

                        </div>
                        <div className="submit-container">
                            {currentQuestionIndex < sessionData.quizzes.length - 1 && (
                            <button className="submit-btn btn-height45" onClick={nextQuestion}>Next</button> )}

                           <span style={{display: currentQuestionIndex >= sessionData.quizzes.length-1 ? '' : 'none'}}>
                                <button
                                className="submit-btn btn-height45"
                                id="submitAnswers" onClick={submitAnswers} disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Submit Answers'}
                                </button>
                            </span>
                        </div>
                    </div>
                  </div>
                )}
                </div>
          )}

          { !sessionCode && userDetails && (
            <div className="form-container form-container-500 white-background padding20">
                {userDetails.Quizzes && userDetails.Quizzes.length > 0 && (
                  <div>
                    <br /><br/>
                    <table className="results-table">
                        <thead>
                            <tr>
                                <th>Quiz
                                    <div style={{fontSize: 'smaller', textAlign: 'right'}}>Date</div>
                                </th>
                                <th>Position</th>
                                <th>Points
                                    <div style={{fontSize: 'smaller', textAlign: 'right'}}>Time</div>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {userDetails.Quizzes.map((quiz, index) => (
                                <tr key={index}>
                                    <td>{quiz.Description}<div style={{fontSize: 'smaller', textAlign: 'right'}}>{quiz.StartedAt.substring(0, 10)   }</div></td>
                                    <td style={{ backgroundColor: GetRankPositionColor(quiz.RankPosition) }}>{quiz.RankPosition}</td>
                                    <td>{quiz.Points}
                                        <div style={{fontSize: 'smaller', textAlign: 'right'}}>
                                            <span style={{ color: quiz.QuizDuration > quiz.AnswerDuration ? 'red' : 'green', fontWeight: quiz.QuizDuration > quiz.AnswerDuration ? 'normal' : 'bold' }}>    
                                            {formatTime(quiz.AnswerDuration)}
                                            </span>
                                            </div>
                                    </td>
                                    <td><button className="btn-nav-admin" onClick={() => { setPopupUserAnswersData(quiz); setShowAnswersPopup(true); }}><img src={imgAnswersIcon} alt="View Image" /></button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    
                </div>
                )}
            </div>
          )}

        {showImagePopup && (
            <div className="image-popup-overlay z100" onClick={() => setShowImagePopup(false)}>
                <div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
                    <button className="close-button" onClick={() => setShowImagePopup(false)}>X</button>
                    <img src={popupImageUrl} alt="Answer Image" style={{maxWidth: '100%', maxHeight: '80vh'}} />
                </div>
            </div>
        )}

        {showAnswersPopup && (
            <div className="image-popup-overlay z90" onClick={() => setShowAnswersPopup(false)}>
                <div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
                    <button className="close-button" onClick={() => setShowAnswersPopup(false)}>X</button>
                    
                    <h3>{popupUserAnswersData.Name}</h3>
                    {popupUserAnswersData.Questions && popupUserAnswersData.Questions.length > 0 ? (
                        <table className="results-table">
                            <thead>
                                <tr>
                                    <th># Q</th>  
                                    <th>Correct answer</th> 
                                    <th>Given answer</th>
                                    <th>Points</th>
                                    <th></th>
                                </tr>   
                            </thead>
                            <tbody>
                                {popupUserAnswersData.Questions.map((answer, index) => (  
                                    <tr key={index} style={{ color: answer.GivenAnswers === answer.CorrectAnswers ? 'green' : 'red', fontWeight: answer.Answers === answer.CorrectAnswers ? 'bold' : 'normal' }}>
                                        <td>{answer.Question}</td>
                                        <td>{answer.CorrectAnswers}</td>
                                        <td>{answer.GivenAnswers}</td>
                                        <td>{answer.Points}</td>
                                        <td><button className="btn-nav-admin" onClick={() => { setPopupImageUrl(answer.Image); setShowImagePopup(true); }}><img src={imgQuestionIcon} alt="View Image" /></button></td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p><br /><br />No answers data available while session is still active.</p>
                    )}

                </div>
            </div>
        )}  


        </>
    )
}